import React from 'react'

function Spinner() {
    return (
        <div id="upload-loading" className="loading">
        <div className="box-text-loading">
            <i className="spinning-loader"></i>
        </div>

    </div>
    )
}



export default Spinner
